<template>
    <div id="lt-yantr" class="oem-level-finance">
        <div class="container fadeInBlock white">
            <div class="oem-financing-tab">
                <div class="row header">
                    <div class="header-title text-left">
                        <h3 class="main-title">Current {{ Make }} financing estimates in {{ GeoLocation.city + ', ' + GeoLocation.state }}</h3>
                        <zipcode-popup
                            v-model="GeoLocation"
                            :showCancelButton="true"
                            headingText="Enter Zip"
                            :locationData="GeoLocation"
                            :submitBtnText="btnText"
                            class="change-location-link"
                            @submitZip="updateLocation"
                        />
                    </div>
                    <div class="header-years text-left">
                        <ul class="tab-name">
                            <li v-for="(years, index) in YearList" :key="index" :class="{'active': ActiveYear == years}" @click="updateTabValues(years)">
                                {{ years }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="tab-content" :class="{'tab-content-loader' : !IsDataLoaded }">
                            <transition v-if="!IsDataLoaded" name="fade">
                                <div class="loader">
                                    <img alt="lt-loader" width="61" height="60" src="data:image/png;base64,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" />
                                    <span>Searching for Vehicles...</span>
                                </div>
                            </transition>
                            <div v-for="(vehicle, index) in resultsToDisplay" v-else :key="index" class="tab-content-details" :class="{'active': true}">
                                <div class="vehicle-section">
                                    <div class="row">
                                        <div class="image-section">
                                            <div class="vehicle-content-wrapper">
                                                <div class="vehicle-img">
                                                    <img v-if="checkImageUrl(vehicle.ImageUrl) != ''" :src="checkImageUrl(vehicle.ImageUrl)" />
                                                    <img v-else src="./images/car.png" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="content-section">
                                            <div class="content-section-data">
                                                <div class="vehicle-content-wrapper">
                                                    <div class="vehicle-desc">
                                                        <div class="vehicle-title">
                                                            {{ vehicle.year + " " + vehicle.make.makeName + " " + vehicle.modelName }}
                                                        </div>
                                                        <div class="vehicle-detail">
                                                            <ul>
                                                                <li>
                                                                    <div class="feature-name">MSRP:</div>
                                                                    <div v-if="vehicle.LowMsrp == null && vehicle.HighMsrp == null" class="feature-value">
                                                                        Loading....
                                                                    </div>
                                                                    <div v-else-if="vehicle.LowMsrp == 0 && vehicle.HighMsrp == 0" class="feature-value">
                                                                        Sorry! Information unavailable.
                                                                    </div>
                                                                    <div v-else-if="vehicle.LowMsrp == 0" class="feature-value">{{ "Up to "+ currencyFilter(vehicle.HighMsrp, 0) }}</div>
                                                                    <div v-else class="feature-value">{{ "$"+ currencyFilter(vehicle.LowMsrp, 0) + " - $"+ currencyFilter(vehicle.HighMsrp, 0) }}</div>
                                                                </li>
                                                                <li class="fair-purchase-price">
                                                                    <div class="feature-name">
                                                                        Invoice Price:
                                                                    </div>
                                                                    <div v-if="vehicle.LowestInvoicePrice == null && vehicle.HighestInvoicePrice == null" class="feature-value">
                                                                        Loading....
                                                                    </div>
                                                                    <div v-else-if="vehicle.LowestInvoicePrice == 0 && vehicle.HighestInvoicePrice == 0" class="feature-value">
                                                                        Sorry! Information unavailable.
                                                                    </div>
                                                                    <div v-else class="feature-value">
                                                                        {{ "$"+ currencyFilter(vehicle.LowestInvoicePrice, 0) +" - $"+ currencyFilter(vehicle.HighestInvoicePrice, 0) }}
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div class="feature-name">Estimated MPG:</div>
                                                                    <div v-if="(vehicle && vehicle.FuelEconomy && vehicle.FuelEconomy.City == null) || (vehicle && vehicle.FuelEconomy && vehicle.FuelEconomy.Highway == null)" class="feature-value">
                                                                        Loading....
                                                                    </div>
                                                                    <div v-else-if="vehicle.FuelEconomy.City == 0 && vehicle.FuelEconomy.Highway == 0" class="feature-value">
                                                                        Sorry! Information unavailable.
                                                                    </div>
                                                                    <div v-else class="feature-value">{{ vehicle.FuelEconomy.City +"/"+ vehicle.FuelEconomy.Highway + " MPG" }}</div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="content-section-action">
                                                <div class="vehicle-content-wrapper">
                                                    <div class="oem-finance-action">
                                                        <button class="btn btn-blue" @click="CalculatePayment(vehicle.make.makeName, vehicle.modelName, vehicle.modelId, vehicle.baseTrimId)">Calculate Payments</button>
                                                        <a href="/redirect/offers?id=wp-auto" class="btn btn-orange">Find Real Finance Quotes</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="IsDataLoaded && Collapsible && VehicleList.length >= 3" class="text-center">
                                <button class="btn more-btn" @click="showMoreOptions(), showMoreResults()">
                                    {{ !ShowMore ? "View More Options" : "Hide" }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { isNullOrUndefined } from '~/helpers/util';
    import Accounting from 'accounting';
    import GetLocation from '~/mixin/get-geo-location';
    import QueryStringHelper from '~/helpers/query-string-helper';
    import ZipcodePopup from './components/zipcode-popup.vue';
    import {
        getTrims as getTrimsSvc, getPrices as getPricesSvc, getTrimDetails as getTrimDetailsSvc, getModelsList as getModelsListSvc, getOEMYearList as getOemYearListSvc,
    } from '~/services/oem-list';
    import BaseMixin from '~/mixin/base-mixin';
    import wwwUrlEnv from '~/helpers/www-url-env';
    import TrackDataHelper from '~/helpers/track-data-helper';
    import AnalyticsTrack from '~/mixin/analytics-track';
    import AnalyticsHelper from '~/helpers/analytics';
    import StringFormat from '~/helpers/string-format';

    export default {
        props: {
            geoLocation: {
                type: Object,
                default() {
                    return {
                        zipCode: '28277',
                        city: 'Charlotte',
                        state: 'NC',
                    };
                },
            },
            btnText: {
                default: 'Change Location',
            },
            makeId: {
                default: 0,
            },
            make: {
                default: '',
            },
            carType: {
                default: 'new',
            },
            yearList: {
                default: '',
            },
            year: {
                default: '',
            },
            vehicleList: {
                type: Array,
                default: () => [],
            },
            showMore: {
                default: false,
            },
            collapsible: {
                default: false,
            },
        },
        data() {
            return {
                GeoLocation: {
                    zipCode: this.geoLocation.zipCode,
                    city: this.geoLocation.city,
                    state: this.geoLocation.state,
                },
                BtnText: this.btnText,
                Make: this.make,
                MakeId: this.makeId,
                CarType: this.carType,
                YearList: this.yearList,
                VehicleList: this.vehicleList,
                ActiveYear: this.year,
                IsDataLoaded: false,
                IsPageloaded: false,
                ShowMore: this.showMore,
                Collapsible: this.collapsible,
            };
        },
        methods: {
            showMoreOptions() {
                this.ShowMore = !this.ShowMore;
            },
            showMoreResults() {
                return this.resultsToDisplay;
            },
            formatDate(disclaimerDate) {
                const date = new Date(disclaimerDate);
                return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
            },
            updateQueryStringParam() {
                window.location.href = `${window.location.href.split('?')[0]}?oem-year=${this.ActiveYear}&zipcode=${this.GeoLocation.zipCode}`;
            },
            updateTabValues(year) {
                if (year !== this.ActiveYear) {
                    this.ActiveYear = year;
                    this.IsDataLoaded = false;
                    this.updateQueryStringParam();
                }
            },
            updateLocation(location) {
                this.GeoLocation = location;
                this.GeoLocation.zipCode = location.zipCode;
                this.updateQueryStringParam();
            },
            fetchoemList() {
                getOemYearListSvc(this.CarType, this.MakeId).then((data) => {
                    this.YearList = data;
                    const year = QueryStringHelper.getQueryStringParam('oem-year');

                    if (data !== undefined && data.length > 0 && year.length > 0) {
                        if (data.length === 1) {
                            this.ActiveYear = data[0];
                        } else if (data.indexOf(parseInt(year, 10)) === -1) {
                            const nearestYear = data[0] > year ? data[0] : data[data.length - 1];
                            window.location.href = `${window.location.href.split('?')[0]}?oem-year=${nearestYear}&zipcode=${this.GeoLocation.zipCode}`;
                            return;
                        }
                    }
                    this.fetchOemDetailList();
                });
            },
            fetchOemDetailList() {
                this.IsDataLoaded = false;

                getModelsListSvc(this.carType, this.MakeId, this.ActiveYear).then((vehicleDetailsList) => {
                    if (this.checkIsNullOrEmpty(vehicleDetailsList)) {
                        vehicleDetailsList.forEach((vehicle, index) => {
                            vehicle.ImageUrl = null;
                            vehicle.HighMsrp = null;
                            vehicle.LowMsrp = null;
                            vehicle.LowestFPP = null;
                            vehicle.HighestFPP = null;
                            vehicle.LowestInvoicePrice = null;
                            vehicle.HighestInvoicePrice = null;
                            vehicle.FuelEconomy = {
                                City: null,
                                Highway: null,
                            };
                            getTrimDetailsSvc(vehicle.baseTrimId).then((trimDetailsList) => {
                                if (trimDetailsList) {
                                    vehicle.ImageUrl = trimDetailsList.imageUrl;
                                    if (trimDetailsList.evaluation) {
                                        vehicle.MSRP = trimDetailsList.evaluation.msrp;
                                    }
                                    if (trimDetailsList.mechanical && trimDetailsList.mechanical.fuelEconomy) {
                                        vehicle.FuelEconomy = {
                                            City: trimDetailsList.mechanical.fuelEconomy.city,
                                            Highway: trimDetailsList.mechanical.fuelEconomy.highway,
                                        };
                                    }
                                }
                                if (index === vehicleDetailsList.length - 1) {
                                    this.refreshVehicleList(vehicleDetailsList);
                                }
                            });
                            getTrimsSvc(vehicle.modelId).then((trimDetailsList) => {
                                if (trimDetailsList) {
                                    trimDetailsList.forEach((trim, trimIndex) => {
                                        if (trim && trim.evaluation) {
                                            if (trimIndex < 1) {
                                                vehicle.LowMsrp = trim.evaluation.msrp;
                                                vehicle.HighMsrp = trim.evaluation.msrp;
                                            } else {
                                                if (trim.evaluation.msrp < vehicle.LowMsrp) {
                                                    vehicle.LowMsrp = trim.evaluation.msrp;
                                                }
                                                if (trim.evaluation.msrp > vehicle.HighMsrp) {
                                                    vehicle.HighMsrp = trim.evaluation.msrp;
                                                }
                                            }
                                        }
                                        getPricesSvc(trim.trimId).then((priceValue) => {
                                            if (priceValue) {
                                                if (trimIndex < 1) {
                                                    vehicle.LowestInvoicePrice = priceValue.invoice;
                                                    vehicle.HighestInvoicePrice = priceValue.invoice;
                                                } else {
                                                    if (priceValue.invoice < vehicle.LowestInvoicePrice) {
                                                        vehicle.LowestInvoicePrice = priceValue.invoice;
                                                    }
                                                    if (priceValue.invoice > vehicle.HighestInvoicePrice) {
                                                        vehicle.HighestInvoicePrice = priceValue.invoice;
                                                    }
                                                }
                                                if (index === vehicleDetailsList.length - 1 && trimIndex === trimDetailsList.length - 1) {
                                                    this.refreshVehicleList(vehicleDetailsList);
                                                }
                                            } else {
                                                vehicle.LowestInvoicePrice = 0;
                                                vehicle.HighestInvoicePrice = 0;
                                            }
                                        });
                                    });
                                }
                            });
                        });
                        this.refreshVehicleList(vehicleDetailsList);
                        this.IsDataLoaded = true;
                        if (this.VehicleList !== undefined && this.VehicleList[0] !== undefined && this.VehicleList[0].make) {
                            this.Make = this.VehicleList[0].make.makeName;
                        }
                    }
                });
            },
            sortOEMList(vehicleDetailsList, key, secondSortKey) {
                const vechicleList = vehicleDetailsList;
                vechicleList.sort((a, b) => {
                    if (a[key] > b[key]) return 1;
                    if (a[key] < b[key]) return -1;

                    if (a[key] === b[key] && a[secondSortKey]) {
                        if (a[secondSortKey] > b[secondSortKey]) return 1;
                        if (a[secondSortKey] < b[secondSortKey]) return -1;
                    }

                    return 0;
                });

                return vechicleList;
            },
            refreshVehicleList(vehicleDetailsList) {
                setTimeout(() => {
                    this.VehicleList = this.sortOEMList(vehicleDetailsList, 'MSRP', 'LowestInvoicePrice');
                }, 500);
            },
            checkCurrentYear() {
                if (this.year === '') {
                    const date = new Date();
                    this.ActiveYear = date.getFullYear();
                }
            },
            CalculatePayment(make, model, modelId, trimId) {
                const makeVal = make.toLowerCase().replace(/ /g, '-');
                const modelVal = `${model.toLowerCase().replace(/ /g, '-')}-${modelId}`;
                const redirectAction = `${wwwUrlEnv.getWWWURL()}/auto/financing/${makeVal}/${modelVal}?oem-year=${this.ActiveYear}&zipcode=${this.GeoLocation.zipCode}&trim=${trimId}`;
                TrackDataHelper.setMany(this.trackVehicleDetails(makeVal, modelVal), 'vehicleDetails');
                AnalyticsHelper.track('Auto OEM Calculate Payment clicked', TrackDataHelper.get('vehicleDetails'));
                window.location.href = redirectAction;
            },
            checkImageUrl(url) {
                return url != null ? url.length > 0 ? url : '' : '';
            },
            getDetailsFromQueryString() {
                const zipCode = QueryStringHelper.getQueryStringParam('zipcode');
                if (zipCode && zipCode.length > 0) {
                    GetLocation.methods.GetZipCode(zipCode, this.checkLocationResponse);
                }
                const year = QueryStringHelper.getQueryStringParam('oem-year');
                if (year && year.length > 0) {
                    this.ActiveYear = year;
                }
            },
            checkLocationResponse(zipDetails) {
                if (!zipDetails.err) {
                    this.GeoLocation = {
                        zipCode: zipDetails.zipCode,
                        state: zipDetails.state,
                        city: zipDetails.city,
                    };
                    if (this.IsPageloaded) {
                        this.updateQueryStringParam();
                    }
                    this.IsPageloaded = true;
                }
            },
            getMakeDetail() {
                const makeName = window.location.href.split('auto/financing/')[1];
                if (makeName && makeName.length > 0) {
                    this.Make = StringFormat.capitalize(makeName.split('/')[0]);
                }
            },
            currencyFilter(figure, precision) {
                return figure > 0 ? Accounting.formatNumber(figure, { precision }) : 0;
            },
            checkIsNullOrEmpty(value) {
                return !isNullOrUndefined(value) && value.length > 0;
            },
        },
        mounted() {
            this.checkCurrentYear();
            setTimeout(() => {
                this.getMakeDetail();
                this.fetchoemList();
                this.getDetailsFromQueryString();
            }, 500);
        },
        computed: {
            resultsToDisplay() {
                if (this.Collapsible && !this.ShowMore) {
                    return this.VehicleList.slice(0, 3);
                }
                return this.VehicleList;
            },
        },
        components: {
            ZipcodePopup,
        },
        mixins: [BaseMixin, AnalyticsTrack, GetLocation],
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss" />
<style src="./main.scss" lang="scss" />
